import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ToastContent } from '../../../components';

import { setLoading } from '../../../store/slices/UI';

export const initToast = {
  initContent: null,
  initVisible: false
};

const { initContent, initVisible } = initToast;

const useToast = () => {
  const [content, setContent] = useState(initContent);
  const [visible, setVisible] = useState(initVisible);
  // Redux
  const dispatch = useDispatch();

  const hideToast = useCallback(() => {
    setVisible(false);
    setContent(null);
  }, []);

  const showSuccess = useCallback(
    (message, callback = undefined) => {
      dispatch(setLoading(false));
      setContent(<ToastContent type='success' message={message} callback={hideToast} />);
      setVisible(true);
      setTimeout(() => {
        hideToast();
        if (callback) callback();
      }, 4000);
    },
    [dispatch, hideToast]
  );

  const showError = useCallback(
    (message, callback = undefined) => {
      dispatch(setLoading(false));
      setContent(<ToastContent type='alert' message={message} callback={hideToast} />);
      setVisible(true);
      setTimeout(() => {
        hideToast();
        if (callback) callback();
      }, 4000);
    },
    [dispatch, hideToast]
  );

  return {
    content: content,
    hideToast: hideToast,
    showSuccess: showSuccess,
    showError: showError,
    visible: visible
  };
};

export default useToast;
